
// This file is auto-generated by 'set-env.ts'.  Adjust any new variables there or configure variables with a .env file.

export const environment = {
	disableCacheInterceptor: false,
	
			exclusive: window['exclusive'],
			apiSettings: window['organizations'],
			apiUrl: window['apiUrl'],
			cmsUrl: window['cmsUrl'],
			cmsToken: window['cmsToken'],
			organizationId: window['organizationId'],
			cmsSiteId: window['cmsSiteId'],
			production: window['production'],
			requireReview: window['requireReview'],
			currencySymbol: window['currencySymbol'],
			currencyCode: window['currencyCode'],
			locale: window['locale'],
			cloudinaryCloudName: window['cloudinaryCloudName'],
			taskerEngineUrl: window['taskerEngineUrl'],
			cloudinaryProxyUrl: window['cloudinaryProxyUrl'],
			briaModifyIframeId: window['briaModifyIframeId'],
			analyticsMode: window['analyticsMode'],
			analytics: window['analytics'],
			hotjarVersion: window['hotjarVersion'],
			hotjarSiteId: window['hotjarSiteId'],
			wppOpenParentOrigin: window['wppOpenParentOrigin'],
			wppOpenDebug: window['wppOpenDebug']
		
};
